import { Navigate } from 'react-router';
import { useBackofficeUser } from '@/hooks/use-backoffice-user';
import { PageLoading } from 'greenback-shared/components';
import { paths } from '@/config/paths';

type AdminRouteProps = {
  children: React.ReactNode;
}

/**
 * Componente per proteggere route accessibili solo agli amministratori
 * Redirige a /dashboard se l'utente non è admin
 */
export const AdminRoute = ({ children }: AdminRouteProps) => {
  const { backofficeUser, isAdmin, loading } = useBackofficeUser();

  if (loading && !backofficeUser) {
    return (
      <div className="flex h-screen items-center justify-center">
        <PageLoading />
      </div>
    );
  }

  if (!backofficeUser) {
    return <Navigate to="/" replace />;
  }

  if (!isAdmin) {
    return <Navigate to={paths.app.dashboard.getHref()} replace />;
  }

  return <>{children}</>;
};
